module.exports = __webpack_public_path__ + "static/media/graduation.703125a0.jpg";